import dayjs from 'shared/helpers/dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export function normalizeTimeToHHMM(
  time: string | null | undefined
): string | null {
  if (!time) return null;
  const trimmed = time.trim();
  if (!trimmed) return null;

  const normalized = trimmed.replace(/\s+([AaPp][Mm])$/, '$1');

  const parsed = dayjs(
    normalized,
    ['HH:mm:ss', 'HH:mm', 'H:mm', 'h:mmA', 'h:mma', 'h:mm A', 'h:mm a'],
    true
  );
  if (!parsed.isValid()) return null;

  return parsed.format('HH:mm');
}

export function isValidHHMM(time: string): boolean {
  const match = time.match(/^(\d{2}):(\d{2})$/);
  if (!match) return false;
  const hh = Number(match[1]);
  const mm = Number(match[2]);
  return hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59;
}

export function formatHHMMToAmPm(time: string): string | null {
  if (!isValidHHMM(time)) return null;
  const parsed = dayjs(time, 'HH:mm', true);
  if (!parsed.isValid()) return null;
  return parsed.format('h:mm A');
}
